import ExportOverview from '../ExportOverview.vue';
import ExportConfig from '../ExportConfig.vue';
import MobilityFlaggingMonitor from '../MobilityFlaggingMonitor.vue';

export default {
  path: '/mobility-flagging',
  name: 'MobilityFlagging',
  redirect: { name: 'ExportConfig' },
  component: ExportOverview,
  meta: { menuItemName: 'MobilityFlagging' },
  children: [
    {
      path: 'config',
      name: 'ExportConfig',
      component: ExportConfig
    },
    {
      path: 'monitor',
      name: 'MobilityFlaggingMonitor',
      component: MobilityFlaggingMonitor
    }
  ]
};
